<template>
  <g-form>
    <div class="g-data-table">
      <!-- @row-dblclick="onDlbRowClick" -->
      <PDataTable
        :allowFiltering="true"
        ref="dt"
        :key="key"
        :loading="carregando"
        :paginator="Paginacao"
        :reorderableColumns="ehReordenavel"
        :rows="NumeroLinhas"
        :scrollable="TemScroll"
        :scrollHeight="altura"
        :sortOrder="1"
        :value="valores"
        @row-click="onRowClick"
        @row-edit-init="onRowEditInit"
        @row-edit-save="onRowEditSave"
        :showGridLines="true"
        responsiveLayoutScroll="scroll"
        editMode="row"
        :resizableColumns="true"
        :autoLayout="true"
        columnResizeMode="expand"
        filterDisplay="menu"
        scrollDirection="horizontal"
        v-model:editingRows="editingRows"
        v-model:selection="linhasSelecionadas"
        v-model:expandedRows="linhasExpandidasInternas"
        :dataKey=dataKey
        :rowGroupMode="campoAgrupador !== null ? 'subheader' : ''"
        :groupRowsBy="campoAgrupador"
        :sortField="campoAgrupador"
        :expandableRowGroups="false" 
        v-model:expandedRowGroups="ProdutosClienteArray"
        @rowExpand="$emit('quandoExpandir',$event)"        
      >
      <!-- Custom header -->
        <template #groupheader="slotProps">
          <span class="image-text">{{slotProps.data[campoExibicaoGrupo]}}</span>
        </template>
        
        <!-- Custom Footer -->
        <template #groupfooter="slotProps">
          <div class="total-container">
          <slot name = "groupfooter" :data = "slotProps" :soma="retornaSoma(slotProps.data[campoAgrupador])" ></slot>  
              <!-- <span class="image-text">{{slotProps.data}}</span> -->
            </div>
     
          </template>
        
        <template #header
        v-if="!esconderHeader">
          <div class="custom-header">
            <slot name="titulo">
              <div class="custom-header-title">{{ Titulo }}</div>
            </slot>

            
            <div class="header-icons-content">
              <g-button
                class="header-icons add-button"
                tipo="cinza"
                altura="40px"
                largura="45px"
                tamanhoIcone="15px"
                icone="pi pi-file-excel"
                :somenteIcone="true"
                v-on:acao="exportCSV"
                :sombreado="false"
                v-if="ExportarExcel"
              />
              <g-button
                class="header-icons add-button"
                altura="40px"
                largura="45px"
                tamanhoIcone="15px"
                icone="pi pi-file-pdf"
                :somenteIcone="true"
                v-on:acao="exportPdf"
                :sombreado="false"
                v-if="ExportarPdf"
              />
             
            </div>
            
            <g-button
              class="header-icons add-button"
              tipo="amarelo"
              altura="40px"
              largura="45px"
              tamanhoIcone="15px"
              icone="icone_add.svg"
              :somenteIcone="true"
              v-on:acao="adicionar"
              v-if="Adicionavel"
              :sombreado="false"
            >
            </g-button>
          </div>
        </template>
        <!-- End Custom header -->

        <PColumn
          v-if="temColunaSelecao"
          selectionMode="multiple"
        ></PColumn>

        <PColumn
          v-if="temColunaSelecaoUnica"
          selectionMode="single"
        ></PColumn>

        <PColumn :field="'Teste'" header="Status" v-if="ButtonStatus" :style="{width: '85px', maxWidth:'85px'}">
          <!-- <template #body="slotProps">
            <div class="StatusRoda" :style="{background: slotProps.data.colorButtonStatus}"></div>
          </template> -->

          <template #body="slotProps">
            <div v-if="slotProps.data.indicadorTexto === null" style="margin-left: 0.6rem;">
              <div
                class="StatusRoda tooltip-personalizado"
                :style="{ background: slotProps.data.colorButtonStatus }"
              ></div>
            </div>

            <VDropdown v-else :distance="20">
              <PButton
                label="Primary"
                v-tooltip="slotProps.data.indicadorTexto"
                class="p-button-icon-only p-button-rounded p-button-text"
              >
                <div
                  class="StatusRoda tooltip-personalizado"
                  :style="{ background: slotProps.data.colorButtonStatus }"
                ></div>
              </PButton>

              <template #popper>
                <div class="indicador">
                  <div class="indicador_titulo">Indicador</div>
                  <div class="periodo-entrega-conteudo"
                    style="min-width: 100px; max-width: 250px; text-align: initial;">
                    {{ slotProps.data.indicadorTexto }}
                  </div>
                </div>
              </template>
            </VDropdown>
          </template>

        </PColumn>
        <!-- TODO: PRECISA FAZER AS COLUNAS FICAREM COM TAMANHO CUSTOMIZAVEL -->
        <!-- fazer uma prop de expandir -->
        <PColumn :expander="ehExpansivel" v-if="ehExpansivel" :style="{width: maxWidthExpansivel,maxWidth: maxWidthExpansivel}"></PColumn>
        <PColumn
        v-for="col of colunas"
        :field="col.field"
        :header="col.header"
        :sortable="col.ordena"
        :key="col.field"
        :sortField="col.ordenacao || col.field"
        :style="{
          // minWidth: '180px',
          width: col.width || '180px' ,
          minWidth: col.width || '180px' ,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontSize: '15px',
          fontWeight: '400',
          color: '#545454',
          display:'flex',
          alignItems: 'center',
          justifyContent: col.alinha || 'flex-start',
          
          }"
        :hidden="mostraColunas"


          >
         

          <template  v-if="ehColunaStatus(col.field) || col.type"  #body="slotProps">
            <div v-if="ehColunaStatus(col.field)" :style="{color: getColorStatus(slotProps.data, col.field), fontWeight: '600'}">{{slotProps.data.orcamentoSincronismoEnum || (col.field === 'dataVencimentoFormatada' ?  slotProps.data.dataVencimentoFormatada : slotProps.data[colunaColorida])}}</div>
            <span v-if="col.type === 'monetario'">
              {{formataValorMonetarioDataTable(slotProps.data[col.field])}}
            </span>   
            <span v-if="col.type === 'number'">
              {{formataValorNumberDataTable(slotProps.data[col.field])}}
            </span>   
          </template>

          <!-- template para aplicação dos filtros por coluna -->
          <template #filter v-if="FiltrosEspecificos === true">
            <PInputText
              type="text"
              v-model="Filtros[col.field].value"
              class="p-column-filter"
              v-if="Filtrable"
              placeholder="Buscar"
              autoFocus
            />
            <i
              class="pi pi-search search-icon"
              v-if="!Filtrable"
              @click="isFiltrable()"
            ></i>
          </template>
          <!-- Crirar um campo de edição para cada coluna na linha -->
          <template #editor="{ data, field }">
            <PInputText v-model="data[field]" autofocus />
          </template>
        </PColumn>
        
        
          
 
        <!-- <Coluna fixa com o ícone de edição> -->
        <PColumn
        v-if = "!esconderColunaFrozen"
          :rowEditor="true"
          :frozen="true"
          :field="'Editor'"
          header="Ações"
          :hidden="EscondeColunaBotao"
          alignFrozen="right"
          :style="{minWidth: sizeAcoes, display: `${EscondeColunaBotao ? 'none' : 'block'}`,}"
        >
          <!-- editorInitCallback chamar editor customizado-->
          <!-- <template #header>
            <div>
                Ações
            </div>
          </template> -->
          <template #body="{ data,index }">
            <VDropdown :distance="2" v-if="maisOpcoes">
                <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text">
                  <div class="pi pi-ellipsis-h" style="font-weight:bolder"></div>
                </PButton>

                <template #popper>
                  <div class="moreOptionsCard">
                    <div class="moreOptions">Mais Opções</div>
                    <PButton
                      label="Primary"
                      class="p-button-icon-only p-button-rounded p-button-text"
                      @click="onNotaFiscal(data)"
                      v-if="VerificarNotaFiscalLista(data.id)"
                      v-tooltip="'Nota fiscal'"
                    >
                      <div class="pi pi-tablet" style="font-weight:bolder"></div>
                    </PButton>

                    <PButton
                      @click="Reorcavels(data)"
                      label="Primary"
                      class="p-button-icon-only p-button-rounded p-button-text"
                      v-if="data.tipoFluxoOrcamento !=1 && data.tipoFluxoOrcamento !=2 && VerificarReorcavel(data.id)"
                      v-tooltip="'Reorçamento'"
                    >
                      <i class="pi pi-sync" style="font-weight:bolder"></i>
                    </PButton>

                    <PButton
                      label="Primary"
                      class="p-button-icon-only p-button-rounded p-button-text"
                      @click="historico()"
                      v-tooltip="'Histórico'"
                    >
                      <div class="pi pi-history" style="font-weight:bolder"></div>
                    </PButton>

                    <PButton
                      label="Primary"
                      class="p-button-icon-only p-button-rounded p-button-text"
                      @click="onCompartilhavel(data)"
                      v-tooltip="'Compartilhar'"
                    >
                      <img src="@/assets/imgs/icone_share.svg" />
                    </PButton>

                    <PButton
                      label="Primary"
                      class="p-button-icon-only p-button-rounded p-button-text"
                      @click="imprimir(data)"
                      v-tooltip="'Imprimir'"
                    >
                      <img src="@/assets/imgs/icone_imprimir.svg" />
                    </PButton>
                  </div>
                </template>
              </VDropdown>

            <div class="EditorColumn">
                  <!-- Button PopUp informações -->
              <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="$emit('clickprancheta', data)"
                v-if="data.status !== null && data.status !== 11 && checkprancheta && (data.status == 10 || data.status == 12 || data.status == 16 || data.status == 18)"
                v-tooltip="`${TextoPrancheta}`"
              >
                <i class="pi pi-angle-double-down"></i>
              </PButton>

              <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="$emit('baixarOrcamentoClick', data)"
                v-if="baixarOrcamento"
                v-tooltip="`Baixar Orçamento`"
              >
                <i class="pi pi-angle-double-down"></i>
              </PButton>

               <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="$emit('baixarCartaProposta', data)"
                v-if="data.status !== null && data.status != 0  && BaixarCartaPropostaBotao"
                v-tooltip="`${TextoBaixaCarta}`"
              >
                <i class="pi pi-angle-double-down"></i>
              </PButton>

              <PButton
                @click="editar(data, index)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Editavel"
                v-tooltip="TextEditar"
              >
                <img src="@/assets/imgs/icone_editar.svg"/>
              </PButton>

              <PButton
                @click="onCopiavel(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Copiavel && data.tipoFluxoOrcamento !=1 "
                v-tooltip="TextCopiar"
                >
                <i class="pi pi-clone" style="font-weight: bold;"></i>
              </PButton>

              <PButton
                @click="imprimir(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Imprimivel"
                v-tooltip="TextImprimir"
              >
                <img src="@/assets/imgs/icone_imprimir.svg" />
              </PButton>


              <PButton
                @click="onCompartilhavel(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Compartilhavel"
                v-tooltip="TextCompartilhar"
              >
                <i class="pi pi-share-alt" style="font-weight: bold;"></i>
              </PButton>

              <PButton
                @click="downloadPDF(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="DownloadPDF"
                v-tooltip="TextDownload"
              >
                <i class="pi pi-download"></i>
              </PButton>

              <PButton
                @click="logout(data, index)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Logout"
                v-tooltip="TextLogout"
              >
                <i class="pi pi-power-off"></i>
              </PButton>

              <PButton
                @click="excluir(data, index)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Excluivel"
                v-tooltip="TextExcluir"
              >
                <i class="pi pi-trash"></i>
              </PButton>

              <PButton
                @click="onDetalhes(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Detalhes"
                v-tooltip="TextDetalhes"
              >
                <i class="pi pi-info-circle" style="font-weight: bold;"></i>
              </PButton>

              <VDropdown :distance="4" v-if="Calendario">
                <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="calendario(data)"
                v-tooltip="'Período de Entrega'"

                >
                  <div class="pi pi-calendar" style="font-weight:bolder"></div>
                </PButton>

                <template #popper>
                  <div class="periodo-entrega-data">
                    <div class="periodo-entrega-titulo">   Período de Entrega </div>
                    <div class="periodo-entrega-conteudo"> {{ data.dataInicio_EntregaFormatada }} </div>
                    <div class="periodo-entrega-conteudo"> à </div>
                    <div class="periodo-entrega-conteudo"> {{data.dataFim_EntregaFormatada }} </div>
                  </div>
                </template>
              </VDropdown>

              <PButton
                @click="onComponentes(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="ComponentesExpandidos"
                v-tooltip="TextComponentes"
              >
                <i class="pi pi pi-sitemap" style="font-weight: bold;"></i>
              </PButton>

              <PButton
                @click="historico()"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Historico"
                v-tooltip="TextHistorico"
              >
                <i class="pi pi-history" style="font-weight:bolder"></i>
              </PButton>

              <PButton
                @click="onNotaFiscal(data)"
                v-if="VerificarNotaFiscalLista(data.id)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-tooltip="TextNotaFiscal"
              >
                <i class="pi pi-reply" style="font-weight: bold;"></i>
              </PButton>

              <PButton
                @click="onPedidos(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Pedidos && data.possuiVinculo == true"
                v-tooltip="TextPedidos"
              >
                <i class="pi pi-book" style="font-weight: bold;"></i>
              </PButton>

              <PButton
                @click="OnParcelas(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Parcelas"
                v-tooltip="TextParcelas"
              >
                <i class="pi pi-credit-card" style="font-weight:bolder"></i>
              </PButton>

              <PButton
                @click="$emit('financeiro',data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Financeiro"
                v-tooltip="TextFinanceiro"
              >
                <i class="pi pi-money-bill" style="font-weight:bolder"></i>
              </PButton>

              <PButton
                @click="carregamento()"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="Carregamento"
                v-tooltip="TextCarregamento"
              >
                <i class="pi pi-car" style="font-weight:bolder"></i>
              </PButton>

              <PButton
                @click="Reorcavels(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="data.tipoFluxoOrcamento !=1 && data.tipoFluxoOrcamento !=2 && VerificarReorcavel(data.id)"
                v-tooltip="'Reorçamento'"
              >
              
                <i class="pi pi-sync" style="font-weight:bolder"></i>
              </PButton>

              <PButton
                @click="OrcaQuantidade(data)"
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                v-if="data.tipoFluxoOrcamento !=1 && (OrcamentoQuantidade && (data.status == 10 || data.status == 12))"
                v-tooltip="'Gerar uma nova opção de quantidade'"
              >
                <i class="pi pi-th-large"></i>
              </PButton>

              <!-- PopUp gerar Orcamento -->
              <!-- <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="GerarOrcaClick(data)"
                v-tooltip="'Gerar orçamento'"
                v-if="GerarOrca"
              >
                <img src="@/assets/imgs/icone_sete_volta.svg" />
              </PButton> -->

              <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="on()"
                v-if="Continuavel"
                v-tooltip="TextContinuar"
              >
                <img src="@/assets/imgs/icone_continuar.svg" />
              </PButton>
              <!-- copiar número do orçamento -->
              <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="CopiaveisClick(data)"
                v-if="Copiaveis && (data.status == 1) && (data.escondeBotao != true)"
                v-tooltip="TextCopiar"
              >
                <img src="@/assets/imgs/icone_docs.svg" />
              </PButton>
              <!-- PopUp gerar Orcamento -->
              <PButton
                label="Primary"
                class="p-button-icon-only p-button-rounded p-button-text"
                @click="GerarOrcaClick(data)"
                v-if="GerarOrca"
              >
                <img src="@/assets/imgs/icone_sete_volta.svg" />
              </PButton>
            </div>
          </template>
          <template #editor="{ editorSaveCallback, editorCancelCallback }">
            <button class="p-row-editor-save p-link" type="button">
              <span
                class="p-row-editor-save-icon pi pi-fw pi-check"
                @click="editorSaveCallback"
              ></span>
            </button>
            <button class="p-row-editor-cancel p-link" type="button">
              <span
                class="p-row-editor-cancel-icon pi pi-fw pi-times"
                @click="editorCancelCallback"
              ></span>
            </button>
          </template>
        </PColumn>

        <template #footer v-if="temFooter">
          <slot name = "footer"  ></slot>
        </template>

        <!-- template que escreve o rowgroup header -->
        <!-- <template #groupheader="slotProps">
          <span>{{ slotProps.data.year }}</span>
        </template> -->

        <template #empty v-if="ehSemDados">
          <div class="empty-container">
            <div class="empty-content">
              <i class="pi pi-exclamation-circle" style="font-size: 2rem"></i>
              <div class="primary-text">{{ TextoVazio }}.</div>
              <div
                v-on:click="adicionar"
                class="secondary-text"
                v-if="Adicionavel"
              >
                Adicionar
              </div>
            </div>
          </div>
        </template>
        <template #expansion="slotProps">
          <slot name = "expansivel" :linha = "slotProps"></slot>
        </template>
        <slot name="colunasManuais"></slot>
      </PDataTable>
    </div>
  </g-form>
</template>

<script>
import g_data_table from "./g-data-table.js";
export default g_data_table;
</script>

<style scoped>
.indicador{
  padding: 0.5rem;
}
.indicador_titulo {
  color: #4f2c19;
  font-size: 14px;
  margin-bottom: 8px;
  border-width: 1px 0;
  text-align: initial;
  font-family: 'MontSerrat';
  font-weight: 600;
}
.periodo-entrega-data {
  text-align: center;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  padding: 10px;
}


.periodo-entrega-titulo, .periodo-entrega-conteudo {
  text-align: center;
  font-family: 'MontSerrat';
  font-weight: 600;
}

.periodo-entrega-titulo {
  color: #4f2c19;
  font-size: 14px;
  margin-bottom: 8px;
  border: solid #e6e6e6;
  border-width: 1px 0;
}

.periodo-entrega-conteudo {
  color: #3e3e3e;
  font-size: 13px;
}

.moreOptionsCard{
  text-align: center;
  font-weight: 600;
  flex-direction: column;
  padding: 10px;
}
.moreOptions{
  color: #4f2c19;
  font-size: 14px;
  margin-bottom: 8px;
  border: solid #e6e6e6;
  border-width: 1px 0;
}

.testeA{
  background-color:tomato ;
}
.testeB{
  background-color:black ;
}
.testeC{
  background-color:greenyellow ;
}

.icone-caminhao {
  color:#4e2b18;
  height: 26px;
  font-weight: bolder;
}

.EditorColumn {
  display: inline-flex;
  justify-content: v-bind('justify');
  width: 100%;
}

.primary-text {
  margin-top: 15px;
  font-weight: lighter;
}
.secondary-text {
  text-decoration: underline;
  color: #4f2c19;
  cursor: pointer;
}

/* Start Header */
.custom-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between !important;
}

.header-form {
  flex: 2;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  padding-right: 0.3rem;
  padding-left: 0.3rem;
}

.header-icons-content {

  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  color: #717171;
}

.global-input-search {
  border-radius: 8px;
}
.StatusRoda{
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
.custom-header-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-self: center;
  font-weight: lighter;
  color: #717171;
}

/* End Header */
.empty-container {

  width:100%;
  display: flex;
  justify-content: center;

  /* background-color: tomato; */
}
.empty-content {

  /* background-color: aqua; */
  margin:0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:center;
  color: #7b7b7b;
}
.search-icon {
  color: #a2a2a8;
}

.pi.pi-tablet {
  transform: rotate(180deg);
}

.total-container{
  display: flex;
  justify-content: flex-start;
  width: 100%;
  background-color:var(--teste-17) ;
  border-bottom: 1px solid #6f7d6c58;

}

.total{
  font-size: 15px;
  font-weight: bold;
}
/* cor do ícone de edição */
:deep(.pi-pencil::before) {
  color: #4e2b18;
}
:deep(.p-column-title) {
  color: #b5b5b5;
  font-weight: 400;
}
:deep(.p-button.p-button-text) {
  color: #4e2b18;
}
:deep(.p-button.p-button-text:enabled:hover) {
  color: #4e2b18 !important;
}
/* Start Título Colunas datagrid */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  color: #717171;
  padding: 0.6rem 2rem;
}

:deep(.p-datatable .p-datatable-header) {
  border-top: v-bind('bordaTopo ? "none":bordaTopo');
  padding: 1.2rem 1rem 1.2rem 2rem;
}

:deep(.p-rowgroup-header) {
  width: 100%;
  background-color: #e6e6e6 !important;
  padding-left: 1rem;
}

:deep(.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:focus) {
  box-shadow: none;
  cursor: pointer;
}

/* End Título Colunas datagrid */

/* Esconder ícone do filtro */
:deep(.pi-filter::before) {
  display: none;
}

:deep(.pi-filter-slash::before) {
  display: none;
}

:deep(.p-column-filter-clear-button:hover) {
  display: none;
}

:deep(.p-column-filter-menu-button) {
  display: none;
}
/* Fim Esconder ícone do filtro */

/* Inicio cor fonte datatable */
:deep(.p-datatable .p-datatable-tbody > tr > td) {
  color: #000000de;
  padding: 0.6rem 2rem;
  border-bottom: v-bind('bordaDatatable ? "1px solid var(--teste-17)" : "none"');
}

:deep(tr .p-rowgroup-header) {
  width: 100%;
  background-color: #e6e6e6 !important;
}

/* fim cor fonte dataTable */

/* Inicio Paginador */
:deep(.p-paginator) {
  padding: 5rem 0.5rem 0;
  border-bottom: none;
}
/* página atual */
:deep(.p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
  background: #ffffff;
  border-color: #ebebeb;
  color: #4f4c4d;
  border-radius: 0px;
}

:deep(.p-link:focus) {
  box-shadow: none;
}

/* setas do paginador */
:deep(.pi-angle-right::before) {
  color: #fcb316;
}
:deep(.p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
  background-color: #ebebeb;
}

:deep(.pi-angle-double-right::before) {
  color: #fcb316;
}

:deep(.pi-angle-left::before) {
  color: #fcb316;
}

:deep(.pi-angle-double-left::before) {
  color: #fcb316;
}

:deep(.p-paginator .p-paginator-next:not(.p-disabled):not(.p-highlight)) {
  border: 2px;
  border-style: solid;
  border-radius: 0px 0px 0px 0px;
  border-color: #ebebeb;
}

:deep(.p-paginator .p-paginator-last:not(.p-disabled):not(.p-highlight)) {
  border: 2px;
  border-style: solid;
  border-radius: 0px 5px 5px 0px;
  border-color: #ebebeb;
}
:deep(.p-paginator .p-paginator-prev:not(.p-disabled):not(.p-highlight)) {
  border: 2px;
  border-style: solid;
  border-radius: 0px 0px 0px 0px;
  border-color: #ebebeb;
}

:deep(.p-paginator .p-paginator-first:not(.p-disabled):not(.p-highlight)) {
  border: 2px;
  border-style: solid;
  border-radius: 5px 0px 0px 5px;
  border-color: #ebebeb;
}
:deep(.p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight)) {
  border: 2px;
  border-style: solid;
  border-radius: 0px 0px 0px 0px;
  border-color: #ebebeb;
}
/* fim setas paginador */
/* fim cor Paginador */
/* start sobreescrevendo p-button*/
:deep(.p-button.p-button-text:enabled:hover) {
  background: #ebebeb;
  color: #ebebeb;
}
:deep(.p-button:focus) {
  box-shadow: none;
}
:deep(.p-button.p-button-text:enabled:active) {
  box-shadow: 0 0 0 0.2rem #a2a2a8;
  transition-duration: 0.1ms;
}
/* end sobrescrevendo p-button */

/* start sobrescrever editor de linha */
/* Botao começar edição */
:deep(.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:focus) {
  box-shadow: none;
}
/* Botao cancelar edição */
:deep(.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:focus) {
  box-shadow: none;
}
/* botão salvar edição */
:deep(.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:focus) {
  box-shadow: none;
}
/* End sobrevrever editor da linha */



@media (min-width:310px) {
    .add-button{
        min-width:2.5rem;
    }
    .header-form {
    width: 100%;
  }

  .header-icons-content {
    flex: 1;
    min-width: 30%;
    max-width: 75%;
    }
  .global-input-search {
    width: 100%;
  }

  :deep(.p-datatable .p-datatable-header) {
  padding: 1.2rem 0 1.2rem 0.5rem;
  }
}

@media (min-width:368px) {
    .header-icons-content {

    flex: 1;
    max-width: 75%;
    }
}

@media (min-width:600px) {
  :deep(.p-datatable .p-datatable-header) {
  padding-left: 2rem;
  }
}

@media (min-width:801px) {

}

@media (min-width:1025px) {
  :deep(.p-datatable .p-datatable-header) {
  padding-right: 1rem;
  }
}

@media (min-width:1281px) {

}

.invisivel{
  visibility: hidden;
}

</style>
